import React, { useState, useEffect } from 'react';
import { useLanguage } from '../hooks/useLanguage';

export const CookieConsent: React.FC = () => {
  const [showConsent, setShowConsent] = useState(false);
  const { isPortuguese } = useLanguage();

  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      setShowConsent(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    setShowConsent(false);
  };

  const declineCookies = () => {
    localStorage.setItem('cookie-consent', 'declined');
    setShowConsent(false);
  };

  if (!showConsent) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-ghost-200 shadow-lg z-50 p-4 sm:p-6">
      <div className="max-w-4xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="flex-1">
            <h3 className="font-semibold text-ghost-800 mb-2">
              {isPortuguese ? '🍪 Uso de Cookies' : '🍪 Cookie Usage'}
            </h3>
            <p className="text-sm text-ghost-600 leading-relaxed">
              {isPortuguese 
                ? 'Utilizamos cookies para melhorar sua experiência e analisar o uso do nosso editor de prompts. Os dados são coletados de forma anônima para fins de análise e melhoria do produto.'
                : 'We use cookies to improve your experience and analyze the usage of our prompt editor. Data is collected anonymously for analysis and product improvement purposes.'
              }
            </p>
          </div>
          <div className="flex gap-3 flex-shrink-0">
            <button
              onClick={declineCookies}
              className="px-4 py-2 text-ghost-600 hover:text-ghost-800 transition-colors text-sm font-medium"
            >
              {isPortuguese ? 'Recusar' : 'Decline'}
            </button>
            <button
              onClick={acceptCookies}
              className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-sm font-medium"
            >
              {isPortuguese ? 'Aceitar' : 'Accept'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};